import React, { useEffect, useState } from "react";

import cover01 from "image/homeCover/1.jpg";
import cover02 from "image/homeCover/2.jpg";
import cover04 from "image/homeCover/4.jpg";
import cover05 from "image/homeCover/5.jpg";
import cover06 from "image/homeCover/6.jpg";

const coverInit = [
	{
		id: "carouse1",
		backgroundImage: `url(${cover01})`,
	},
	{
		id: "carouse2",
		backgroundImage: `url(${cover02})`,
	},
	{
		id: "carouse4",
		backgroundImage: `url(${cover04})`,
	},
	{
		id: "carouse5",
		backgroundImage: `url(${cover05})`,
	},
	{
		id: "carouse6",
		backgroundImage: `url(${cover06})`,
	},
];

const HomeCover = () => {
	const [current, setCurrent] = useState(0);
	const [carouselList, setCarouselList] = useState(coverInit);
	const [imageCarousel, setImageCarousel] = useState({});

	useEffect(() => {
		setCarouselList(coverInit);
	}, []);

	useEffect(() => {
		const next = (current + 1) % carouselList.length;
		const id = setTimeout(() => setCurrent(next), 3000);
		setImageCarousel({
			width: `${100 * carouselList.length}%`,
			transform: `translateX(${(100 / carouselList.length) * current * -1}%)`,
		});
		return () => clearTimeout(id);
	}, [current, carouselList]);

	return (
		<section className="HomeCover padding-header">
			<div className="coverBg">
				<ul style={imageCarousel}>
					{carouselList.map((el) => {
						return <li style={el} key={el.id}></li>;
					})}
				</ul>
			</div>
			<div className="dim"></div>
			<div className="con">
				<div className="wrap-cover">
					<h1 className="cover-slogan">
						<span className="color-main">Solid is</span>
						<br />
						<span className="color-sub">Better than Liquid</span>
					</h1>
					<p>
						동구밭은 프랑스 이브비건 인증과
						<br />
						미국 농무부 USDA 유기농 인증을
						<br />
						최초로 동시에 받은 화장품 제조사입니다
					</p>
				</div>

				<div className="cover-pagenation">
					<ul>
						{carouselList.map((el, index) => {
							return <li key={el.id} className={current === index ? "active" : ""}></li>;
						})}
					</ul>
				</div>
			</div>
		</section>
	);
};

export default HomeCover;
